module.exports = "/account/components/billingSummaryComponent-f8b9a7.html";